import React from "react";
import { LABELS } from "@/common/constants/constants";
import { v4 as uuidv4 } from "uuid";
import aboutCompanyDataFetch from "@/data/domain/about-company.json";

import styles from "./AboutCompanySpecial.module.scss";

const AboutCompanySpecial = () => {
  return (
    <div className={styles.wrapper}>
      <h2 className={styles.title}>{LABELS.WHAT_MAKES_US_SPECIAL}</h2>
      <div className={styles.cardsWrapper}>
        {aboutCompanyDataFetch?.special.map((item) => {
          return (
            <div className={styles.card} key={uuidv4()}>
              <img
                src={item.icon}
                alt={item.altIcon}
                className={styles.cardIcon}
                width={74}
                height={80}
              />
              <div className={styles.cardDetails}>
                <h3 className={styles.cardTitle}>{item.title}</h3>
                <div className={styles.description}>{item.description}</div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AboutCompanySpecial;
